<div
  class="pnl-promotions"
  [class.open]="open"
  infiniteScroll
  [fromRoot]="true"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="20"
  [infiniteScrollContainer]="selector"
  (scrolled)="onScroll()"
>
  <header>
    <h1>Promoções</h1>
    <a [routerLink]="['/app/descontos/promocao']">Criar nova promoção</a>
  </header>
  <section class="pnl">
    <ul class="tabs">
      <li
        class="ativo"
        (click)="changeTab('ativo')"
        [class.active]="tab == 'ativo'"
      >
        <a>
          <span>{{ num_ativo }}</span>
          <strong>Ativo</strong>
        </a>
      </li>
      <li
        class="agendado"
        (click)="changeTab('agendado')"
        [class.active]="tab == 'agendado'"
      >
        <a>
          <span>{{ num_agendado }}</span>
          <strong>Agendado</strong>
        </a>
      </li>
      <li
        class="expirado"
        (click)="changeTab('expirado')"
        [class.active]="tab == 'expirado'"
      >
        <a>
          <span>{{ num_expirado }}</span>
          <strong>Expirado</strong>
        </a>
      </li>
      <li
        class="todos"
        (click)="changeTab('todos')"
        [class.active]="tab == 'todos'"
      >
        <a>
          <h4>{{ num_todos }}</h4>
          <strong>Todos</strong>
        </a>
      </li>
    </ul>
    <div
      class="promotions"
      [class.todos]="tab == 'todos'"
      [class.ativo]="tab == 'ativo'"
    >
      <div
        *ngFor="let c of promotions; let i = index"
        (click)="openDetail(c, i)"
        [class.active]="i == openid && c.idpromocao == promotion.idpromocao"
        class="promotion"
      >
        <div class="descricao">
          <strong>{{ c.descricao }}</strong>
          <span>{{ c.descritivo }}</span>
        </div>
        <div class="aplicado">
          {{ c.aplicados }} {{ c.aplicados <= 1 ? "Aplicado" : "Aplicados" }}
        </div>
        <div class="status">
          <b *ngIf="c.ativo" class="ativo">Ativo</b>
          <b *ngIf="c.agendado" class="agendado">Agendado</b>
          <b *ngIf="c.expirado" class="expirado">Expirado</b>
        </div>
        <div class="data">
          {{ c.observacao }}
        </div>
      </div>
      <div class="promotions-loading" *ngIf="loadingPromotion && !loadingTab">
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
          <div class="ldio-ns36390yc">
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-loading" *ngIf="loadingTab">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </section>
  <aside id="detailPromotion" class="detail">
    <form [formGroup]="promotionFrm" (ngSubmit)="onSubmit()" novalidate>
      <header *ngIf="!isDeletePromotion">
        <div class="action-status">
          <div class="ipt-switch">
            <input
              id="ckStatus"
              type="checkbox"
              (change)="updateStatus()"
              formControlName="status"
              name="status"
            />
            <label for="ckStatus"></label>
          </div>
          <span>Promoção {{ status.value ? "ativa" : "inativa" }}</span>
        </div>

        <a (click)="closeDetail()" class="btn-close"></a>
        <div
          class="btn-option"
          (click)="toggleOptions()"
          (mouseout)="hideOptions()"
          [class.open]="optionOpen"
        >
          <i></i>
          <i></i>
          <i></i>
          <div (mouseover)="clearOptions()" (mouseout)="hideOptions()">
            <a
              [routerLink]="['/app/descontos/promocao/' + promotion.idpromocao]"
              >Editar promoção <i class="ic ic-pen"></i
            ></a>
            <a (click)="showDeletePromotion()"
              >Excluir promoção <i class="ic ic-delete"></i
            ></a>
          </div>
        </div>
      </header>

      <section *ngIf="isDeletePromotion" class="detailPromotionDelete">
        <i class="ic ic-ticket-delete"></i>
        <h3>Tem certeza que deseja excluir esta promoção?</h3>
        <p>
          <strong>Não é aconselhável excluir promoções.</strong><br />
          Esteja ciente sobre a perda dos dados estatísticos.
        </p>
      </section>

      <section>
        <div class="relatorio">
          <strong> Relatório de atividades </strong>
          <div>
            <span>Promoção aplicada em</span>
            <span
              >{{ promotion.aplicados }} pedido{{
                promotion.aplicados > 1 ? "s" : ""
              }}</span
            >
          </div>
          <div *ngIf="promotion.tipo_limite == 'V'">
            <span>Investimento máximo</span>
            <span>R$ {{ promotion.investimento_maximo | number: ".2" }}</span>
          </div>
          <div *ngIf="promotion.tipo_limite == 'V'">
            <span>Investido</span>
            <span
              >R$
              {{
                (promotion.investido ? promotion.investido : "0") | number: ".2"
              }}</span
            >
          </div>
          <div *ngIf="promotion.tipo_limite == 'Q'">
            <span>Quantidade máxima</span>
            <span>{{ promotion.quantidade_maxima }}</span>
          </div>
          <div *ngIf="promotion.dt_criacao">
            <span>Criado em</span>
            <span>{{
              promotion.dt_criacao.replace(" ", "T") | date: "d/MM/y"
            }}</span>
          </div>
          <div>
            <span>Criado por</span>
            <span>{{ promotion.nome }}</span>
          </div>

          <div *ngIf="promotion.dt_inicio">
            <span>Inicia em</span>
            <span>{{
              promotion.dt_inicio.replace(" ", "T") | date: "d/MM/y"
            }}</span>
          </div>

          <div *ngIf="promotion.dt_expiracao && promotion.flag_final == 'D'">
            <span *ngIf="promotion.expirado">Expirado em</span>
            <span *ngIf="!promotion.expirado">Expira em</span>
            <span>{{
              promotion.dt_expiracao.replace(" ", "T") | date: "d/MM/y"
            }}</span>
          </div>

          <div *ngIf="promotion.flag_final == 'L' && promotion.tipo_limite">
            <span style="font-size: 14px"
              >O término ocorrerá quando o limite de
              {{
                promotion.investimento_maximo > 0
                  ? "investimento"
                  : "quantidade"
              }}
              alcançar</span
            >
          </div>
        </div>
      </section>
    </form>
    <footer *ngIf="isDeletePromotion">
      <button (click)="onDeletePromotion()" class="btn btn-danger">
        Sim! Quero excluir
      </button>
      <button (click)="showDeletePromotion()" class="btn btn-primary-outline">
        Cancelar exclusão
      </button>
    </footer>

    <div *ngIf="showConfirmDelete" class="showConfirmDelete">
      <i class="ic ic-delete-confirm"></i>
      <strong>Excluído com sucesso</strong>
    </div>

    <div class="loading" *ngIf="loadingDetail!!; loadingDelete">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </aside>
</div>
